import React, { useState } from "react";
import { RotateCcw } from "lucide-react";
import { PracticeSheet } from "./PracticeSheet";
import { SERIF } from "./practiceApi";

// One tap to begin a fresh 21 days — opens set-up with their previous choices pre-filled.
export const RestartButton = ({ prev, label = "Begin a new 21 days" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="practice-restart-btn"
        className="inline-flex items-center gap-2 rounded-full bg-[#d7bb7a] px-6 py-3 text-xs uppercase tracking-[0.26em] text-[#0b1a33] transition-opacity hover:opacity-90">
        <RotateCcw size={14} /> {label}
      </button>
      {open && <PracticeSheet open={open} onOpenChange={setOpen} journeyId={prev.journey_id} initial={prev} />}
    </>
  );
};

export const RestartCard = ({ last }) => (
  <section className="rounded-3xl border border-[#d7bb7a]/25 bg-[#10213f] p-6" data-testid="practice-restart-card">
    <p className="text-[0.62rem] uppercase tracking-[0.3em] text-[#d7bb7a]">21-Day Practice · {last.journey_name}</p>
    <h2 className="mt-2 text-2xl text-[#f3ecd9]" style={{ fontFamily: SERIF }}>Ready for another 21 days?</h2>
    <p className="mt-2 text-sm text-[#cfc6ae]">Start again with the same installation. Your previous times are already filled in, so you can keep them or change them.</p>
    <div className="mt-5"><RestartButton prev={last} /></div>
  </section>
);
